export const QUESTIONEAR_VIEW_SET = 'QUESTIONEAR_VIEW_SET';
export const QUESTIONEAR_SELECTED_SET = 'QUESTIONEAR_SELECTED_SET';